import React from "react";
import simon from "../images/simon.png";
import dbank from "../images/dbank.png";

const Project = () => {
  return (
    <div className="projects-content">
      <h1>&#60; featured projects /&#62;</h1>
      <p>here are some projects I've worked/currently working on:</p>
      <div>
        <a href="https://github.com/luisgustavogorniak/simon-game">
          <img className="projectimg" src={simon} alt="simon game layout" />
        </a>
        <p>A web application where you get to play the Simon game!</p>
      </div>
      <div>
        <a href="https://github.com/luisgustavogorniak/dbank-web3">
          <img className="projectimg" src={dbank} alt="dbank page layout" />
        </a>
        <p>
          A full stack web 3 application using motoko language mocking a bank
          account to top up and withdraw fake money values.
        </p>
      </div>
    </div>
  );
};

export default Project;
